module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/277.3046a2a0.png";